import { Outlet, useLocation } from "react-router-dom";
import { propertiesRoutes } from "../../../app/routes";
import { selectInitializeToken } from "../../../app/slices/authSlice";
import { useTypedSelector } from "../../../app/stores/store";
import Breadcrumb from "../../../components/breadcrumb/Breadcrumb";
import FooterPanel from "../../../components/navigation/footerPanel/FooterPanel";
import HeaderPanel from "../../../components/navigation/headerPanel/HeaderPanel";
import CustomSpinner from "../../../components/spinner/CustomSpinner";
import { useAuthInit } from "../../../hooks/useAuthInit";
import { useBrowserTabTitle } from "../../../hooks/useBrowserTabTitle";
import ErrorNotice from "../../error/errorNotice/ErrorNotice";
import { selectIsAuthExpiredOrMissingError } from "../../error/errorNotice/errorNoticeSlice";
import "./RootLayout.scss";

const RootLayout = () => {
  const { pathname } = useLocation();
  const initializeToken = useTypedSelector(selectInitializeToken);
  const isAuthExpiredOrMissingError = useTypedSelector(selectIsAuthExpiredOrMissingError);
  const [isAuthInitLoading, isAuthInitError] = useAuthInit(pathname);
  useBrowserTabTitle(propertiesRoutes.property.path);

  const isErrorMessageVisible = isAuthInitError || isAuthExpiredOrMissingError;
  if (isErrorMessageVisible) {
    return (
      <div className="root-layout">
        <ErrorNotice title={""} />
      </div>
    );
  }

  const isLoadingScreenVisible = isAuthInitLoading || !initializeToken;
  if (isLoadingScreenVisible) {
    return (
      <div className="root-layout">
        <CustomSpinner isFullScreen={true} />
      </div>
    );
  }

  return (
    <div className="root-layout">
      <header className="container-fluid">
        <HeaderPanel />
        <Breadcrumb />
      </header>
      <Outlet />
      <footer>
        <FooterPanel />
      </footer>
    </div>
  );
};

export default RootLayout;
